import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  buttonContainer: {
    width: '100%',
    alignItems: 'stretch',
    justifyContent: 'flex-end',
  },

  timelineChart: {
    height: 106,
    width: 260,
    justifyContent: 'flex-end',
  },
  timelineChartArrow: {
    width: 'auto',
    bottom: theme.spacing[2],
  },
  timelineCard: {
    backgroundColor: colors.backgroundPrimaryInverse,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.xs,
    paddingVertical: theme.spacing[3],
    paddingHorizontal: theme.spacing[1],
    gap: theme.spacing[1],
  },
  dateTimeline: {
    width: '100%',
    height: 8,
    backgroundColor: colors.backgroundDisabled,
    borderRadius: theme.borderRadius.full,
    overflow: 'hidden',
  },
  dateTimelineProgress: {
    height: '100%',
    width: 195,
    backgroundColor: colors.backgroundBrand,
  },
  timelineLabels: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  animatedContainer: {
    position: 'absolute',
    right: 20,
    top: 0,
    width: 100,
  },
}));
